import React, { useEffect, useRef } from "react";

const brands = [
  { src: process.env.PUBLIC_URL + "/images/brands/berger.jpg", name: "Brand One" },
  { src: process.env.PUBLIC_URL + "/images/brands/asian.jpg", name: "Brand Two" },
  { src: process.env.PUBLIC_URL + "/images/brands/sheenlac.jpg", name: "Brand Three" },
  { src: process.env.PUBLIC_URL + "/images/brands/esdee.jpg", name: "Brand Four" },
  { src: process.env.PUBLIC_URL + "/images/brands/Fevicol.jpg", name: "Brand Five" },
  { src: process.env.PUBLIC_URL + "/images/brands/drfix.png", name: "Brand Six" },
  { src: process.env.PUBLIC_URL + "/images/brands/Araldite.jpg", name: "Brand Seven" }
];

const loopBrands = [...brands, ...brands];

export default function BrandsCarousel() {
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const rafRef = useRef(0);
  const lastTsRef = useRef(0);
  const xRef = useRef(0);
  const pausedRef = useRef(false);
  const halfWidthRef = useRef(0);
  const speedRef = useRef(40);

  useEffect(() => {
    const track = trackRef.current;
    const container = containerRef.current;
    if (!track || !container) return;

    const compute = () => {
      halfWidthRef.current = track.scrollWidth / 2;
    };

    const setSpeed = () => {
      const vw = window.innerWidth;
      speedRef.current = vw <= 600 ? 60 : vw <= 900 ? 50 : 40; // px/sec
    };

    setSpeed();
    compute();

    const onResize = () => {
      setSpeed();
      compute();
    };

    const pause = () => { pausedRef.current = true; };
    const resume = () => { pausedRef.current = false; };

    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);
    container.addEventListener("touchstart", pause, { passive: true });
    container.addEventListener("touchend", resume);
    window.addEventListener("resize", onResize);

    const step = (ts) => {
      if (!lastTsRef.current) lastTsRef.current = ts;
      const dt = (ts - lastTsRef.current) / 1000;
      lastTsRef.current = ts;

      if (!pausedRef.current) {
        xRef.current -= speedRef.current * dt;
        const hw = halfWidthRef.current || 0;
        if (hw > 0 && xRef.current <= -hw) {
          xRef.current += hw; // carry forward to avoid any visible jump
        }
        track.style.transform = `translateX(${xRef.current}px)`;
      }

      rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);

    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", onResize);
      container.removeEventListener("mouseenter", pause);
      container.removeEventListener("mouseleave", resume);
      container.removeEventListener("touchstart", pause);
      container.removeEventListener("touchend", resume);
    };
  }, []);

  return (
    <section className="brands section">
      <h2>Our Brands</h2>
      <div className="brands-carousel" ref={containerRef}>
        <div className="carousel-track" ref={trackRef}>
          {loopBrands.map((b, i) => (
            <div className="brand-card" key={i}>
              <img src={b.src} alt={b.name} className="brand-logo" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}